<template>
  <section class="cte h-screen" ref="cte">
    <div class="w-full h-full bg-black pt-40 lg:pt-100 px-16 lg:px-160 relative z-0">
      <!-- tree image     -->
      <div class="h-auto tree-container tree-wrapper">
        <img
            :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/cleanToEarn/tree.png') : require('@/assets/images/pages/main/cleanToEarn/mTree.png')"
            alt="" class="tree">
        <!-- leaf image @todo : animation 'on' class 추가     -->
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf1 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf2.png" alt="" class="leaf2 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf3.png" alt="" class="leaf3 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf4.png" alt="" class="leaf4 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf5.png" alt="" class="leaf5 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf6 on absolute">
      </div>
      <div class="h-auto tree-container bg-tree-0">
        <img
            :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/cleanToEarn/tree.png') : require('@/assets/images/pages/main/cleanToEarn/mTree.png')"
            alt="" class="tree">
        <!-- leaf image @todo : animation 'on' class 추가     -->
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf1 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf2.png" alt="" class="leaf2 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf3.png" alt="" class="leaf3 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf4.png" alt="" class="leaf4 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf5.png" alt="" class="leaf5 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf6 on absolute">
      </div>
      <div class="h-auto tree-container bg-tree-1">
        <img
            :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/cleanToEarn/tree.png') : require('@/assets/images/pages/main/cleanToEarn/mTree.png')"
            alt="" class="tree">
        <!-- leaf image @todo : animation 'on' class 추가     -->
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf7 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf2.png" alt="" class="leaf8 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf3.png" alt="" class="leaf9 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf4.png" alt="" class="leaf10 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf5.png" alt="" class="leaf11 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf12 on absolute">
      </div>
      <div class="h-auto tree-container bg-tree-2">
        <img
            :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/cleanToEarn/tree.png') : require('@/assets/images/pages/main/cleanToEarn/mTree.png')"
            alt="" class="tree">
        <!-- leaf image @todo : animation 'on' class 추가     -->
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf7 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf2.png" alt="" class="leaf8 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf3.png" alt="" class="leaf9 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf4.png" alt="" class="leaf10 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf5.png" alt="" class="leaf11 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf12 on absolute">
      </div>
      <div class="h-auto tree-container bg-tree-3">
        <img
            :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/cleanToEarn/tree.png') : require('@/assets/images/pages/main/cleanToEarn/mTree.png')"
            alt="" class="tree">
        <!-- leaf image @todo : animation 'on' class 추가     -->
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf1 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf2.png" alt="" class="leaf2 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf3.png" alt="" class="leaf3 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf4.png" alt="" class="leaf4 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf5.png" alt="" class="leaf5 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf6 on absolute">
      </div>
      <div class="h-auto tree-container bg-tree-4">
        <img
            :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/cleanToEarn/tree.png') : require('@/assets/images/pages/main/cleanToEarn/mTree.png')"
            alt="" class="tree">
        <!-- leaf image @todo : animation 'on' class 추가     -->
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf13 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf2.png" alt="" class="leaf14 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf3.png" alt="" class="leaf15 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf4.png" alt="" class="leaf16 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf5.png" alt="" class="leaf17 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf18 on absolute">
      </div>
      <div class="h-auto tree-container bg-tree-5">
        <img
            :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/cleanToEarn/tree.png') : require('@/assets/images/pages/main/cleanToEarn/mTree.png')"
            alt="" class="tree">
        <!-- leaf image @todo : animation 'on' class 추가     -->
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf7 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf2.png" alt="" class="leaf8 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf3.png" alt="" class="leaf9 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf4.png" alt="" class="leaf10 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf5.png" alt="" class="leaf11 on absolute">
        <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf12 on absolute">
      </div>

      <!-- @todo : 이산화탄소 수치 animation      -->
      <div class="ppm blex">
        <canvas ref="carbon"></canvas>
        <div class="ppm-text absolute text-white font-bold text-3xl text-center">
          <div class="blex w-full text-lg">
            <number :from="carbonVal" :to="carbonValTo" easing="Power1.easeOut" :duration="0.5"
                    :format="(val) => val.toFixed(1)"/>
            kg
          </div>
          <div class="w-full blex">
            CO2
          </div>
        </div>
      </div>

      <div class="blex bg-black w-full"
      >
        <div class="text-white font-bold text-2xl lg:text-6xl blex bottom-gradient pb-12">
          CLEAN TO EARN
        </div>
      </div>
      <div class="details">
        <!-- clean to earn  설명     -->
        <div class="w-full detail-wrapper">
          <div class="detail">
            {{ $t('cleanToEarn.1') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.2') }}

          </div>
        </div>

        <div class="w-full detail-wrapper">
          <div class="detail blex-right text-right">
            {{ $t('cleanToEarn.3') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.4') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.5') }}
          </div>
        </div>

        <div class="w-full detail-wrapper">
          <div class="detail">
            {{ $t('cleanToEarn.6') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.7') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.8') }}
          </div>
        </div>

        <div class="w-full detail-wrapper">
          <div class="detail blex-right text-right">
            {{ $t('cleanToEarn.9') }}<br>
            {{ $t('cleanToEarn.10') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.11') }}
          </div>
        </div>

        <div class="w-full detail-wrapper">
          <div class="detail">
            {{ $t('cleanToEarn.12') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.13') }}
          </div>
        </div>

        <div class="w-full detail-wrapper">
          <div class="detail blex-right text-right">
            {{ $t('cleanToEarn.14') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.15') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.16') }}<br class="hidden lg:block">
            {{ $t('cleanToEarn.17') }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Tree from './Tree'

let timeline = null
export default {
  name: 'CleanToEarn',
  components: {
    Tree
  },
  data: () => ({
    carbonVal: 0,
    carbonValTo: 0,
    waitingChildrenCount: 0
  }),
  methods: {
    carbonCanvasInit() {
      /* super inefficient right now, could be improved */
      const canvas = this.$refs['carbon'],
          ctx = canvas.getContext('2d'),
          cw = canvas.width = 400,
          ch = canvas.height = 300,
          rand = function (a, b) {
            return ~~((Math.random() * (b - a + 1)) + a)
          },
          dToR = function (degrees) {
            return degrees * (Math.PI / 180)
          },
          circle = {
            // x: (cw / 2) + 5,
            x: (cw / 2),
            // y: (ch / 2) + 22,
            y: (ch / 2),
            radius: 90,
            speed: 2,
            rotation: 0,
            angleStart: 270,
            angleEnd: 90,
            hue: 220,
            thickness: 18,
            blur: 25
          },
          particles = [],
          particleMax = 100,
          updateCircle = () => {
            if (circle.rotation < 360) {
              circle.rotation += circle.speed
            } else {
              circle.rotation = 0
            }
          },
          renderCircle = () => {
            ctx.save()
            ctx.translate(circle.x, circle.y)
            ctx.rotate(dToR(circle.rotation))
            ctx.beginPath()
            ctx.arc(0, 0, circle.radius, dToR(circle.angleStart), dToR(circle.angleEnd), true)
            ctx.lineWidth = circle.thickness
            ctx.strokeStyle = gradient1
            ctx.stroke()
            ctx.restore()
          },
          renderCircleBorder = () => {
            ctx.save()
            ctx.translate(circle.x, circle.y)
            ctx.rotate(dToR(circle.rotation))
            ctx.beginPath()
            ctx.arc(0, 0, circle.radius + (circle.thickness / 2), dToR(circle.angleStart), dToR(circle.angleEnd), true)
            ctx.lineWidth = 2
            ctx.strokeStyle = gradient2
            ctx.stroke()
            ctx.restore()
          },
          renderCircleFlare = () => {
            ctx.save()
            ctx.translate(circle.x, circle.y)
            ctx.rotate(dToR(circle.rotation + 185))
            ctx.scale(1, 1)
            ctx.beginPath()
            ctx.arc(0, circle.radius, 30, 0, Math.PI * 2, false)
            ctx.closePath()
            const gradient3 = ctx.createRadialGradient(0, circle.radius, 0, 0, circle.radius, 30)
            gradient3.addColorStop(0, 'hsla(330, 50%, 50%, .35)')
            gradient3.addColorStop(1, 'hsla(330, 50%, 50%, 0)')
            ctx.fillStyle = gradient3
            ctx.fill()
            ctx.restore()
          },
          renderCircleFlare2 = () => {
            ctx.save()
            ctx.translate(circle.x, circle.y)
            ctx.rotate(dToR(circle.rotation + 165))
            ctx.scale(1.5, 1)
            ctx.beginPath()
            ctx.arc(0, circle.radius, 25, 0, Math.PI * 2, false)
            ctx.closePath()
            const gradient4 = ctx.createRadialGradient(0, circle.radius, 0, 0, circle.radius, 25)
            gradient4.addColorStop(0, 'hsla(30, 100%, 50%, .2)')
            gradient4.addColorStop(1, 'hsla(30, 100%, 50%, 0)')
            ctx.fillStyle = gradient4
            ctx.fill()
            ctx.restore()
          },
          createParticles = () => {
            if (particles.length < particleMax) {
              particles.push({
                x: (circle.x + circle.radius * Math.cos(dToR(circle.rotation - 85))) + (rand(0, circle.thickness * 2) - circle.thickness),
                y: (circle.y + circle.radius * Math.sin(dToR(circle.rotation - 85))) + (rand(0, circle.thickness * 2) - circle.thickness),
                vx: (rand(0, 100) - 50) / 1000,
                vy: (rand(0, 100) - 50) / 1000,
                radius: rand(1, 6) / 2,
                alpha: rand(10, 20) / 100
              })
            }
          },
          updateParticles = () => {
            let i = particles.length
            while (i--) {
              const p = particles[i]
              p.vx += (rand(0, 100) - 50) / 750
              p.vy += (rand(0, 100) - 50) / 750
              p.x += p.vx
              p.y += p.vy
              p.alpha -= .01

              if (p.alpha < .02) {
                particles.splice(i, 1)
              }
            }
          },
          renderParticles = () => {
            let i = particles.length
            while (i--) {
              const p = particles[i]
              ctx.beginPath()
              ctx.fillRect(p.x, p.y, p.radius, p.radius)
              ctx.closePath()
              ctx.fillStyle = `hsla(0, 0%, 100%, ${p.alpha})`
            }
          },
          clear = () => {
            ctx.globalCompositeOperation = 'destination-out'
            ctx.fillStyle = 'rgba(0, 0, 0, .1)'
            ctx.fillRect(0, 0, cw, ch)
            ctx.globalCompositeOperation = 'lighter'
          },
          loop = () => {
            clear()
            updateCircle()
            renderCircle()
            renderCircleBorder()
            renderCircleFlare()
            renderCircleFlare2()
            createParticles()
            updateParticles()
            renderParticles()
          }

      /* Append Canvas */
      //document.body.appendChild(c);

      /* Set Constant Properties */
      ctx.shadowBlur = circle.blur
      ctx.shadowColor = `hsla(${circle.hue}, 80%, 60%, 1)`
      ctx.lineCap = 'round'

      const gradient1 = ctx.createLinearGradient(0, -circle.radius, 0, circle.radius)
      gradient1.addColorStop(0, `hsla(${circle.hue}, 60%, 50%, .25)`)
      gradient1.addColorStop(1, `hsla(${circle.hue}, 60%, 50%, 0)`)

      const gradient2 = ctx.createLinearGradient(0, -circle.radius, 0, circle.radius)
      gradient2.addColorStop(0, `hsla(${circle.hue}, 100%, 50%, 0)`)
      gradient2.addColorStop(.1, `hsla(${circle.hue}, 100%, 100%, .7)`)
      gradient2.addColorStop(1, `hsla(${circle.hue}, 100%, 50%, 0)`)

      /* Loop It, Loop It Good */
      setInterval(loop, 16)
    },
    initTreeAnimation() {
      const timeline = this.$gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          scroller: '#index',
          trigger: 'section.cte',
          start: 'top',
          end: '1400%',
          pin: true,
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      })

      timeline.fromTo('.tree-wrapper', {
        scale: 0.5,
        x: '-50%',
        bottom: '-50%'
      }, {
        duration: 20,
        scale: 1,
        bottom: 0,
        ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)'
      }).to('.tree-wrapper', {
        duration: 10,
        opacity: 0,
        ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)'
      })

      timeline.fromTo('.ppm', {
        opacity: 0
      }, {
        duration: 10,
        opacity: 1,
        ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)'
      })

      const texts = this.$gsap.utils.toArray('.detail-wrapper')

      texts.forEach((text, i) => {
        timeline.from(text, {opacity: 0, y: '0%'})
            .call((params) => {
              this.carbonValTo = (params + 1) * 0.2
            }, [i])
            .to(text, {duration: 10, opacity: 1, y: '50%', ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)', delay: 20})
            .fromTo(`.bg-tree-${i}`, {
              opacity: 0,
              scale: 0,
              y: '50%'
            }, {
              duration: 10,
              opacity: 1,
              scale: 1,
              y: 0,
              ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)'
            }, '-=1')
            .to(text, {duration: 10, opacity: 0, y: '0%', ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)', delay: 20})
      })

      return timeline
    },
    initTreeAnimationMobile() {
      const timeline = this.$gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          scroller: '#index',
          trigger: 'section.cte',
          start: 'top',
          end: '700%',
          pin: true,
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
          // invalidateOnRefresh: true,
          // pinSpacing: false
        }
      })

      timeline.fromTo('.tree-wrapper', {
        scale: 0.5,
        x: '-50%',
        bottom: '-50%'
      }, {
        duration: 10,
        scale: 1,
        bottom: 0,
        ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)'
      }).to('.tree-wrapper', {
        duration: 10,
        opacity: 0,
        ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)'
      })

      timeline.fromTo('.ppm', {
        opacity: 0
      }, {
        duration: 10,
        opacity: 1,
        ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)'
      })

      const texts = this.$gsap.utils.toArray('.detail-wrapper')

      texts.forEach((text, i) => {
        timeline.from(text, {opacity: 0, y: '-50%'})
            .call((params) => {
              this.carbonValTo = (params + 1) * 0.2
            }, [i])
            .to(text, {duration: 10, opacity: 1, y: '15%', ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)', delay: 20})
            .fromTo(`.bg-tree-${i}`, {
              opacity: 0,
              scale: 0,
              y: '50%'
            }, {
              duration: 10,
              opacity: 1,
              scale: 1,
              y: 0,
              ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)'
            }, '-=1')
            .to(text, {duration: 10, opacity: 0, y: '-50%', ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)', delay: 20})
      })

      return timeline
    },
    animations() {
      // gsap
      this.$scrollTrigger.matchMedia({
        '(min-width: 1025px)': () => {
          if (timeline) {
            timeline.kill()
            timeline = null
          }

          timeline = this.initTreeAnimation()

          return () => {
            if (timeline) {
              timeline.kill()
              timeline = null
            }
          }
        },
        '(max-width: 1024px)': () => {
          if (timeline) {
            timeline.kill()
            timeline = null
          }

          timeline = this.initTreeAnimationMobile()

          return () => {
            if (timeline) {
              timeline.kill()
              timeline = null
            }
          }
        }
      })

    }
  },
  mounted() {
    this.carbonCanvasInit()
  },
  beforeDestroy() {
    if (timeline) {
      timeline.kill()
    }
  }
}
</script>

<style scoped lang="scss">
section::v-deep {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  height: 100vh;

  .details {
    width: 100%;
    position: relative;

    .detail-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      opacity: 0;
      z-index: 10;
      background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0) 100%);
      backdrop-filter: blur(3px);

      .detail {
        padding-top: 50px;
        width: 100%;
        color: #fff;
        font-weight: 500;
        font-size: 16px;
        line-height: 25px;
        z-index: 2;

        @media screen and (max-width: 1024px) {
          font-size: 13px;
          width: 100%;
        }
      }
    }
  }

  //이산화탄소 그래프 css
  //canvas {
  //  background: #131c35 linear-gradient(#192853, #131c35);
  //  display: block;
  //  float: left;
  //
  //  /* uncomment to test overlay */
  //
  //  /*
  //  position: absolute;
  //  left: 0;
  //  opacity: .5;
  //  top: 0;
  //  */
  //
  //}

  .tree-wrapper {
    position: absolute;
    left: 50%;
    top: 350px;
    z-index: 1;
  }

  .bg-tree-0 {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
    width: 270px;
    @media screen and (max-width: 1024px) {
      width: 30%;
    }
  }

  .bg-tree-1 {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 270px;
    @media screen and (max-width: 1024px) {
      width: 30%;
    }
  }

  .bg-tree-2 {
    position: absolute;
    left: 15%;
    bottom: 0;
    z-index: 1;
    width: 180px;

    @media screen and (max-width: 1024px) {
      width: 20%;
    }
  }

  .bg-tree-3 {
    position: absolute;
    right: 15%;
    bottom: 0;
    z-index: 1;
    width: 180px;
    @media screen and (max-width: 1024px) {
      width: 20%;
    }
  }

  .bg-tree-4 {
    position: absolute;
    left: 25%;
    bottom: 0;
    z-index: 1;
    width: 90px;
    @media screen and (max-width: 1024px) {
      width: 14%;
    }
  }

  .bg-tree-5 {
    position: absolute;
    right: 25%;
    bottom: 0;
    z-index: 1;
    width: 90px;
    @media screen and (max-width: 1024px) {
      width: 14%;
    }
  }


  .ppm {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .ppm-text {
    }
  }

  // trees
  .tree-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    .tree {
      width: 100%;
    }

    .leaf1 {
      &.on {
        animation: leaf1 3s 1.3s linear infinite;
        bottom: 50%;
      }
    }

    .leaf2 {
      &.on {
        animation: leaf2 2s .5s linear infinite;
        bottom: 50%;
      }
    }

    .leaf3 {
      &.on {
        animation: leaf3 3.5s 0s linear infinite;
        bottom: 50%;
      }
    }

    .leaf4 {
      &.on {
        animation: leaf4 2s .8s linear infinite;
        bottom: 50%;
      }
    }

    .leaf5 {
      &.on {
        animation: leaf5 2.5s 0s linear infinite;
        bottom: 50%;
      }
    }

    .leaf6 {
      &.on {
        animation: leaf6 2.3s 1.3s linear infinite;
        bottom: 50%;
      }
    }

    .leaf7 {
      &.on {
        animation: leaf7 2s 0s linear infinite;
        bottom: 50%;
      }
    }

    .leaf8 {
      &.on {
        animation: leaf8 3.5s 0s linear infinite;
        bottom: 50%;
      }
    }

    .leaf9 {
      &.on {
        animation: leaf9 4s 0s linear infinite;
        bottom: 50%;
      }
    }

    .leaf10 {
      &.on {
        animation: leaf10 5s 0s linear infinite;
        bottom: 50%;
      }
    }

    .leaf11 {
      &.on {
        animation: leaf11 3.5s 1s linear infinite;
        bottom: 50%;
      }
    }

    .leaf12 {
      &.on {
        animation: leaf12 3s 1.5s linear infinite;
        bottom: 50%;
      }
    }

    .leaf13 {
      &.on {
        animation: leaf13 3s 1.5s linear infinite;
        bottom: 50%;
      }
    }

    .leaf14 {
      &.on {
        animation: leaf14 1s 1s linear infinite;
        bottom: 50%;
      }
    }

    .leaf15 {
      &.on {
        animation: leaf15 .5s 1.2s linear infinite;
        bottom: 50%;
      }
    }

    .leaf16 {
      &.on {
        animation: leaf16 4s 2.2s linear infinite;
        bottom: 50%;
      }
    }

    .leaf17 {
      &.on {
        animation: leaf17 1s 1.2s linear infinite;
        bottom: 50%;
      }
    }

    .leaf18 {
      &.on {
        animation: leaf18 2s 1s linear infinite;
        bottom: 50%;
      }
    }


    @keyframes leaf1 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      50% {
        transform: translate(100%, -1000%) rotate(90deg);
      }

      100% {
        transform: translate(0, -2000%) rotate(180deg);
        opacity: 0;
      }
    }

    @keyframes leaf2 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      50% {
        transform: translate(100%, -1000%) rotate(90deg);
      }

      100% {
        transform: translate(0, -2000%) rotate(180deg);
        opacity: 0;
      }
    }

    @keyframes leaf3 {
      0% {
        transform: translate(200%) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-200%, -2000%) rotate(180deg);
        opacity: 0;
      }
    }

    @keyframes leaf4 {
      0% {
        transform: translate(150%) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-150%, -500%) rotate(180deg);
        opacity: 0;
      }
    }

    @keyframes leaf5 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(300%, -1800%) rotate(180deg);
        opacity: 0;
      }
    }

    @keyframes leaf6 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-100%, -1200%) rotate(180deg);
        opacity: 0;
      }
    }

    @keyframes leaf7 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(200%, -1000%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf8 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(300%, -1700%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf9 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(500%, -2000%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf10 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(1000%, -1800%) rotate(320deg);
        opacity: 0;
      }
    }
    @keyframes leaf11 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-150%, -700%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf12 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-200%, -800%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf13 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-200%, -800%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf14 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-50%, -800%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf15 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(350%, -800%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf16 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(800%, -800%) rotate(180deg);
        opacity: 0;
      }
    }
    @keyframes leaf17 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-400%, -800%) rotate(180deg);
        opacity: 0;
      }
    }

    @keyframes leaf18 {
      0% {
        transform: translate(0) rotate(0);
        opacity: 1;
      }
      100% {
        transform: translate(-500%, -800%) rotate(180deg);
        opacity: 0;
      }
    }


  }
}

</style>
